import React from 'react';
import classNames from 'classnames';
import { getCellModifierByType, getTitleByType } from './enums';

const QualLeaderboardRowTitle = (
    {
        type,
        sortingHandler,
        processingState,
        inOutTotal
    }
) => {
    const isActive = processingState.sortingType === type;
    const stateCss = classNames({
        'is-active': isActive,
        'is-top': isActive && processingState.isSortingAscending
    });

    const modifier = getCellModifierByType(type);
    const title = getTitleByType(type);

    function getNationalityTitle(titleParam) {
        if (titleParam === 'nationality') {
            return 'nat';
        }
        return titleParam;
    }

    return (
        <div
            className={`qual-leaderboard__cell qual-leaderboard__cell--title qual-leaderboard__cell--${modifier} ${stateCss}`}>
            <button
                className="qual-leaderboard__cell-content-title"
                type="button"
                onClick={() => sortingHandler(type)}
            >
                <div className="qual-leaderboard__cell-title">{getNationalityTitle(title)}</div>
                {(modifier === 'in' || modifier === 'out' || modifier === 'total') && (
                    <div className="qual-leaderboard__cell-name-value">{inOutTotal}</div>
                )}
                <div className="qual-leaderboard__cell-title-icon-wrapper">
                    <svg className="qual-leaderboard__cell-title-icon icon" width="9" height="6" focusable="false">
                        <use xlinkHref="#icon-triangle"></use>
                    </svg>
                </div>
            </button>
            <div className="qual-leaderboard__cell-title-m">{getNationalityTitle(title)}</div>
        </div>
    );
};

export default QualLeaderboardRowTitle;
